// src/landing/AdFrame.jsx
// ─── Encadrement publicitaire réutilisable (§17-23) ─────────────────────────
// Les mêmes slots — lead_left et lead_right — servent /leads ET les
// formulaires personnalisés que les professionnels envoient à leurs prospects.
// Aucune seconde table (§19) : une publicité changée dans l'admin change aux
// deux endroits, ce qui est exactement l'intention.
//
// §23 — Les slots sont GLOBAUX VehicleIQ. Ils ne reçoivent, ne lisent et ne
// modifient aucune donnée du professionnel : ce composant ne connaît ni le
// token du formulaire, ni son propriétaire, ni ses prospects.
//
// §21 — Un slot inactif ne rend rien. La grille est centrée, donc le
// formulaire se recentre de lui-même sans placeholder vide.

import { useState, useEffect } from "react";
import "./landing.css";

function Slot({ ad, position }) {
  if (!ad || !ad.is_active || !ad.desktop_image_url) return null;
  const img = <img src={ad.desktop_image_url} alt={ad.alt_text || "Publicité partenaire"} width={300} height={600} loading="lazy" className="lv2-ad-img" />;
  return (
    <aside className={`lv2-ad lv2-ad-${position}`} aria-label="Publicité partenaire">
      {ad.target_url ? <a href={ad.target_url} target="_blank" rel="noopener noreferrer sponsored">{img}</a> : img}
      <span className="lv2-ad-tag">Publicité</span>
    </aside>
  );
}

function MobileSlot({ ad }) {
  if (!ad || !ad.is_active || !ad.mobile_image_url) return null;
  const img = <img src={ad.mobile_image_url} alt={ad.alt_text || "Publicité partenaire"} width={320} height={100} loading="lazy" className="lv2-ad-img" />;
  return (
    <aside className="lv2-ad-mobile" aria-label="Publicité partenaire">
      {ad.target_url ? <a href={ad.target_url} target="_blank" rel="noopener noreferrer sponsored">{img}</a> : img}
      <span className="lv2-ad-tag">Publicité</span>
    </aside>
  );
}

// Chargement partagé : une seule requête, mise en cache par le navigateur
// (Cache-Control 120 s côté serveur).
export function useAdSlots(apiUrl = "") {
  const [ads, setAds] = useState({ lead_left: null, lead_right: null });
  useEffect(() => {
    let alive = true;
    fetch(`${apiUrl}/api/public/ad-slots`).then(r => r.json())
      .then(j => { if (alive && j?.success) setAds(j.slots || {}); })
      .catch(() => {});
    return () => { alive = false; };
  }, [apiUrl]);
  return ads;
}

export default function AdFrame({ apiUrl = "", children, maxWidth = 680 }) {
  const ads = useAdSlots(apiUrl);
  return (
    <>
      <div className="lv2-adframe">
        <Slot ad={ads.lead_left} position="left" />
        <div className="lv2-adframe-content" style={{ maxWidth }}>{children}</div>
        <Slot ad={ads.lead_right} position="right" />
      </div>
      <MobileSlot ad={ads.lead_left || ads.lead_right} />
    </>
  );
}
